import { Injectable, inject } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { CustomSnackbarComponent } from '../_metronic/shared/snackbar/snackbar.component';

@Injectable({
    providedIn: 'root'
})
export class FirebaseMessagingService {
    private messaging: Messaging = inject(Messaging);
    private snackBar: MatSnackBar = inject(MatSnackBar);
    constructor() { }

    /**
     * Requests permission from the user to show notifications.
     */
    // requestPermission() {
    //     getToken(this.messaging, { vapidKey: environment.firebase.vapidKey })
    //         .then((currentToken) => {
    //             if (currentToken) {
    //                 console.log('Firebase registration token: ', currentToken);
    //                 localStorage.setItem('fcmToken', currentToken);    
    //                 // TODO: Send this token to your server to send notifications later.
    //             } else {
    //                 console.log('No registration token available. Request permission to generate one.');
    //             }
    //         }).catch((err) => {
    //             console.error('An error occurred while retrieving token. ', err);
    //         });
    // }

    async requestPermission() {
        try {
            const registration = await navigator.serviceWorker.register('firebase-messaging-sw.js');

            // Now call getToken with the registered service worker
            const currentToken = await getToken(this.messaging, {
                vapidKey: environment.firebase.vapidKey,
                serviceWorkerRegistration: registration
            });

            if (currentToken) {
                console.log('Firebase registration token: ', currentToken);
                localStorage.setItem('fcmToken', currentToken);
                // TODO: Send this token to your server to send notifications later.
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }

        } catch (err) {
            // console.error('An error occurred while retrieving token.', err);
        }
    }

    /**
     * Listens for incoming messages when the app is in the foreground.
     */
    /*
    listenForMessages() {
        onMessage(this.messaging, (payload) => {
            const message = payload.notification?.body as string;
            const action = 'Close';

            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                duration: 0,
                horizontalPosition: 'end',
                verticalPosition: 'top',
                panelClass: ['snackbar-container'],
                data: {
                    title: payload.notification?.title as string,
                    body: payload.notification?.body as string
                }
            });
            console.log('Message received. ', payload);
            // TODO: Display the notification to the user (e.g., with a toast).
        });
    }
    */
    listenForMessages() {
        onMessage(this.messaging, (payload) => {
          console.log('Message received. ', payload);
                
          const notification = payload.notification;
          const title = notification?.title || 'Notification';
          const body = notification?.body || '';
          const image = notification?.image || null;
            
          // Ambil action dari payload.data atau fallback
          const actions = (payload.data?.actions) ? JSON.parse(payload.data.actions): 
              [
                { label: 'Open', action: 'open' },
                { label: 'Dismiss', action: 'dismiss' }
              ];
          
          console.log(actions); // array tombol
          // Tampilkan snackbar
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            duration: 0,
            horizontalPosition: 'end',
            verticalPosition: 'top',
            panelClass: ['custom-snackbar'],
            data: {
              title,
              body,
              image,   // diteruskan ke komponen agar bisa ditampilkan
              actions, // diteruskan agar bisa render button
            }
          });
        });
    }
}